import { render, staticRenderFns } from "./LocationGroupList.vue?vue&type=template&id=69116fa3"
import script from "./LocationGroupList.vue?vue&type=script&lang=ts"
export * from "./LocationGroupList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports